webpackJsonp([119199911606483],{

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/services_fc.9f8b26a3.jpg";

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PageHeader = __webpack_require__(23);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _services_fc = __webpack_require__(608);
	
	var _services_fc2 = _interopRequireDefault(_services_fc);
	
	var _ShareButtons = __webpack_require__(31);
	
	var _ShareButtons2 = _interopRequireDefault(_ShareButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pageMeta = {
	  title: "Free Consultation"
	};
	var AboutPage = function AboutPage(_ref) {
	  var transition = _ref.transition;
	  return _react2.default.createElement(
	    'div',
	    { style: transition && transition.style, className: 'page' },
	    _react2.default.createElement(_PageHeader2.default, { bgPhoto: _services_fc2.default, cover: true, styles: { backgroundColor: "#747173" } }),
	    typeof window !== 'undefined' && _react2.default.createElement(_ShareButtons2.default, { location: location.href, desc: pageMeta.desc }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'title-bar' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          pageMeta.title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          pageMeta.desc
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Many patients choose to have treatments performed on the day of their consultation.\xA0\xA0If you would like to have treatment on the same day as the initial consultation, please make sure to schedule accordingly.\xA0\xA0Please make sure that all of your questions are answered to your satisfaction prior to receiving treatment.\xA0\xA0On the day of your consultation, wash your face thoroughly with antibacterial soap and do not apply foundation or other makeup to the area which is being treated.\xA0\xA0These consultations are complimentary.'
	      )
	    )
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-free-consultation-js-54bac94a0f38709b5c38.js